import React, { useEffect } from 'react';
import { useAuthenticationContext } from '../../core/services/AuthenticationProvider';
import { Loader } from '../../core/components';

const SignInCallbackRoute = () => {
  const authContext = useAuthenticationContext();
  
  useEffect(() => {
    if(authContext && authContext.signinRedirectCallback){
      authContext.signinRedirectCallback();
    }
  },[]);

  return (
    <Loader main={true} opacity={1} />
  );
};

export default SignInCallbackRoute;
